<script setup lang="ts">
import LightBulbIcon from '@/assets/icons/LightBulbIcon.vue';

defineProps<{
  canManagePerformanceAssessments: boolean;
}>();
</script>

<template>
  <div v-if="canManagePerformanceAssessments" class="flex items-start gap-sm p-sm">
    <LightBulbIcon class="flex-shrink-0 w-icon-md h-icon-md" />
    <div class="text-secondary leading-[27px]">
      {{ $t('performanceAssessment.noPAsYetForSubject') }}
    </div>
  </div>
  <div v-else class="flex items-start p-sm">
    <div class="text-secondary leading-[27px]">
      {{ $t('general.noResults') }}
    </div>
  </div>
</template>
